import React, { Component } from 'react'
import { compose } from 'redux'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Form, Row, Col, Container, Card, Button, Alert } from 'react-bootstrap'
import ReCAPTCHA from 'react-google-recaptcha'
import PropTypes from 'prop-types'
import * as mapDispatchToProps from '../../actions'
import { renderTextField } from '../form_elements'
import { RECAPTCHA_SITE_KEY } from '../../client_settings'

class ForgotPassword extends Component {
  constructor(props) {
    super(props)

    this.recaptchaRef = React.createRef()
  }

  componentWillUnmount() {
    this.props.leaveLoginForm()
  }

  async handleFormSubmit({ email }) {
    let reCaptcha = RECAPTCHA_SITE_KEY ? await this.recaptchaRef.current.executeAsync() : null
    this.props.forgotPassword({ email, reCaptcha })
  }

  renderSuccess() {
    if (this.props.successMessage) {
      return (
        <Card className='form-signin'>
          <Card.Body>
            <h5 className='form-signin-heading'>Forgot Password</h5>
            <div className='alert alert-success'>
              <strong>Success!</strong> {this.props.successMessage}
            </div>
            <div className='h-100'>
              <Col className='d-flex justify-content-center'>
                <Link className='text-muted text-link' to={'/login'}>
                  Back to Login
                </Link>
              </Col>
            </div>
          </Card.Body>
        </Card>
      )
    }
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return (
        <Alert variant='danger'>
          <strong>Oops!</strong> {this.props.errorMessage}
        </Alert>
      )
    } else if (this.props.successMessage) {
      return (
        <Alert variant='success'>
          <strong>Sweet!</strong> {this.props.successMessage}
        </Alert>
      )
    }
  }

  renderForm() {
    if (!this.props.successMessage) {
      const { handleSubmit, submitting, valid } = this.props

      const recaptcha = RECAPTCHA_SITE_KEY ? (
        <span>
          <ReCAPTCHA ref={this.recaptchaRef} sitekey={RECAPTCHA_SITE_KEY} size='invisible' />
          <br />
        </span>
      ) : null

      return (
        <Card>
          <Card.Body>
            <h5 className='form-signin-heading'>Forgot Password</h5>
            <Form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
              <Row>
                <Field name='email' component={renderTextField} placeholder='Email Address' />
              </Row>
              {recaptcha}
              {this.renderAlert()}
              <div className='d-grid'>
                <Button variant='outline-primary' type='submit' disabled={submitting || !valid}>
                  Submit
                </Button>
                <hr />
                <div className='h-100'>
                  <Col className='d-flex justify-content-center'>
                    <Link className='text-muted text-link' to={'/login'}>
                      Back to Login
                    </Link>
                  </Col>
                </div>
              </div>
            </Form>
          </Card.Body>
        </Card>
      )
    }
  }

  render() {
    return (
      <Container>
        <Row className='pt-4 justify-content-center'>
          <Col sm={6} md={5} lg={4} xl={3}>
            {this.renderSuccess()}
            {this.renderForm()}
          </Col>
        </Row>
      </Container>
    )
  }
}

ForgotPassword.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  forgotPassword: PropTypes.func.isRequired,
  leaveLoginForm: PropTypes.func.isRequired,
  successMessage: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired
}

const validate = (formProps) => {
  const errors = {}
  if (!formProps.email) {
    errors.email = 'Required'
  }

  return errors
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.error,
    successMessage: state.auth.message
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'forgotPassword',
    validate: validate
  })
)(ForgotPassword)
